module.exports = __webpack_public_path__ + "static/media/PC_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.a605bd55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/prep_cert/PC_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.png
// module id = 248
// module chunks = 0